module.exports = __webpack_public_path__ + "img/BestEmployee.903adb20.svg";